import client from "../Client/HttpClient";
import { IPreschoolEvaluationsModel } from "@/interfaces/modules";

const ApiPath = "PreschoolEvaluations";

export default {
  /** GET api/PreschoolEvaluations */
  GetAll: (): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/PreschoolEvaluations/{id} */
  GetById: (id: number): Promise<IPreschoolEvaluationsModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/PreschoolEvaluations/byStudent/{studentId} */
  GetByStudentId: (studentId: number): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}/byStudent/${studentId}`),

   GetByYear: (data: IPreschoolEvaluationsModel): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}/byYear/${data.AcademicYearId}/${data.GroupId}/${data.TeacherId}`),

  /** GET api/PreschoolEvaluations/byPeriod/{periodId} */
  GetByPeriodId: (data: IPreschoolEvaluationsModel): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}/byPeriod/${data.PeriodId}/${data.GroupId}/${data.TeacherId}`),

  /** GET api/PreschoolEvaluations/byDimension/{dimensionId} */
  GetByDimensionId: (dimensionId: number): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}/byDimension/${dimensionId}`),

  /** GET api/PreschoolEvaluations/byTeacher/{teacherId} */
  GetByTeacherId: (teacherId: number): Promise<IPreschoolEvaluationsModel[]> =>
    client.get(`${ApiPath}/byTeacher/${teacherId}`),

  /** POST api/PreschoolEvaluations */
  Post: (data: IPreschoolEvaluationsModel): Promise<IPreschoolEvaluationsModel> =>
    client.post(`${ApiPath}`, data),
};
